import { renderPriceColumn } from 'containers/Reports/utils';
import dayjs from 'dayjs';

const columns = (isMobile) => [
  {
    title: 'ORDER ID',
    dataIndex: 'order_id',
    key: 'order_id',
    width: '140px',
    fixed: isMobile ? false : 'left',
  },
  {
    title: 'DATE',
    dataIndex: 'order_date',
    key: 'order_date',
    width: '180px',
    render: (value) => (value === '–' || value == null ? '–' : dayjs(value).utc(true).format('MMM D, YYYY hh:mm A')),
  },
  {
    title: 'MERCHANT',
    dataIndex: 'merchant',
    key: 'merchant',
    width: '220px',
    ellipsis: true,
  },
  {
    title: 'EXPEDITE DELIVERY FEE',
    dataIndex: 'expedite_delivery_fee',
    key: 'expedite_delivery_fee',
    width: '180px',
    render: renderPriceColumn,
  },
  {
    title: 'EXPEDITE TIP',
    dataIndex: 'expedite_tip',
    key: 'expedite_tip',
    width: '140px',
    render: renderPriceColumn,
  },
];

export default columns;
